import {Component} from '@angular/core';
import {SearchService} from '../services/search';
import {RoutesService} from '../services/routes';

@Component({
    selector: 'search-results',
    templateUrl: '../views/search-results.pug',
    styles: [`
      h4 {
        display: inline-block;
        margin-right: 10px;
      }
      .type {
        display: inline-block;
      }
      .type .badge {
        text-transform: capitalize;
        margin-top: -5px;
      }
    `],
})
export class SearchResultsComponent {
  constructor(public search:SearchService, private routes:RoutesService) {}
}



// WEBPACK FOOTER //
// ./src/app/components/search-results.ts